import * as React from "react"
import type { SVGProps } from "react"
const SvgRecommendationOutgoingOnly = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6.48 12.46a6.1 6.1 0 0 0 5.24 1.06 5.8 5.8 0 0 0 3.65-2.8l.09-.15-1.23.33a1 1 0 0 1-.74-.1 1 1 0 0 1-.47-.6 1 1 0 0 1 .1-.74q.22-.37.6-.47l3.55-.95a.96.96 0 0 1 1.21.7l.95 3.55q.1.38-.11.74a1 1 0 0 1-.6.47 1 1 0 0 1-.73-.1 1 1 0 0 1-.47-.6l-.33-1.23-.09.16a7.7 7.7 0 0 1-4.87 3.73 7.8 7.8 0 0 1-7.1-1.53 8 8 0 0 1-.9-.86 1 1 0 0 1-.22-.73q.05-.41.41-.64.36-.22.77-.16t.72.39q.25.3.57.53" />
  </svg>
)
export default SvgRecommendationOutgoingOnly
